import { AnnouncementResponseDto } from "../shared/dtos/announcement/AnnouncementResponseDto";
import { AnnouncementSummaryDto } from "../shared/dtos/announcement/AnnouncementSummaryDto";

export class AnnouncementMapper {
  public static mapAnnouncementToSummary(
    announcement: AnnouncementResponseDto,
  ): AnnouncementSummaryDto {
    return {
      id: announcement.id,
      title: announcement.title,
      content: announcement.content,
      publishDate: announcement.publishDate,
      expiryDate: announcement.expiryDate,
      audience: announcement.audience,
      branchId: announcement.branchId,
      branchName: announcement.branchName,
      authorId: announcement.authorId,
      authorName: announcement.authorName,
      createdAt: announcement.createdAt,
      updatedAt: announcement.updatedAt,
    };
  }
}
